const initialState = {
   data:[],
   pmh:[],
   currentmedication:[],
   ros:[],
   complaint:[],
   exam:[],
   assisment:[],
   diag:[],
    
  
  };
  
  const DoctorNotesReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA1_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_DATA2_SUCCESS':
            return {... state, pmh:action.payload};
            case 'FETCH_DATA3_SUCCESS':
            return {... state, currentmedication:action.payload};
            case 'FETCH_DATA4_SUCCESS':
            return {... state, ros:action.payload};
            case 'FETCH_DATA5_SUCCESS':
            return {... state, complaint:action.payload};
            case 'FETCH_DATA6_SUCCESS':
            return {... state, exam:action.payload};
            case 'FETCH_DATA7_SUCCESS':
            return {... state, assisment:action.payload};
            case 'FETCH_DATA8_SUCCESS':
            return {... state, diag:action.payload};
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default DoctorNotesReducers;
  
  